export const routeNames = {
   '/':'Home',
   '/search':'Search',
   '/catalog':'Catalog',
   '/login':'Login',
   '/register':'Register',
   '/logout':'Logout',
   '/faq':'FAQ',
   '/terms':'Terms',
   '/profile':'Profile',
   '/transactions/:invoice_number':'TransactionDetail',
   '/transactions':'TransactionList',
   '/certificate/:uuid':'Certificate',
   '/coupon/:uuid':'CourseCoupon',
   '/course/catalog/':'CourseCatalog',
   '/course/invoice/:invoice_number':'CourseOrderConfirmation',
   '/course/:uuid/order':'CourseOrder',
   '/course/:uuid/recap':'CourseRecap',
   '/course/:uuid/certificate':'CourseCertificate',
   '/course/:uuid/:enroll?':'CourseDetail',
   '/event/catalog':'EventCatalog',
   '/event/:uuid/order/success':'EventOrderConfirmation',
   '/event/:uuid/order':'EventOrder',
   '/event/:uuid/ticket':'EventTicket',
   '/event/:uuid/:buy?':'EventDetail',
   '/quiz/result/:uuid/:recap?':'QuizResult',
   '/quiz/:uuid':'QuizAttempt',
   '/learning-path/catalog':'LearningPathCatalog',
   '/learning-path/:uuid/certificate':'LearningPathCertificate',
   '/learning-path/:uuid':'LearningPathDetail',
   '/community/catalog':'CommunityCatalog',
   '/community/register':'CommunityRegister',
   '/community/:uuid':'CommunityDetail',
   '/academia/dashboard':'AcademiaDashboard',
   '/academia/faq':'AcademiaFAQ',
   '/academia/history':'AcademiaHistory',
   '/academia/member':'AcademiaMember',
   '/help/form':'HelpForm',
   '/help':'Help'
};

export const EventCategories = [
    {id: "20", name:"Vaganza"},
    {id: "21", name:"SPT"},
    {id: "22", name:"Discovery"},
    {id: "23", name:"OPT"},
    {id: "24", name:"Training Reguler"},
    {id: "25", name:"Tematik Leader"},
    {id: "26", name:"Internal"},
    {id: "27", name:"Vision"}
];



// WEBPACK FOOTER //
// ./src/components/Consts.js